export interface TenantDataType {}

export class TenantData implements TenantDataType {}
